import { isBubbleChartFieldInfo, isBubbleChartStringField } from './predicates';
import type {
  LabelFilter,
  BubbleChartViewSettings,
  BubbleChartSelectedFieldInfo,
  FieldData,
} from './types';
import {
  getAvailableFieldsOfType,
  type AvailableReferenceModeFields,
} from './availableFieldsOfType';

export const isLabelFilterValid = (
  labelFilter: LabelFilter,
  viewSettings: BubbleChartViewSettings
): boolean => {
  const currentFieldValue = viewSettings[labelFilter.dimension];

  if (!currentFieldValue) {
    return false;
  }

  if (
    typeof currentFieldValue === 'string' &&
    typeof labelFilter.fieldName === 'string'
  ) {
    return currentFieldValue === labelFilter.fieldName;
  }

  if (
    isBubbleChartFieldInfo(currentFieldValue) &&
    isBubbleChartFieldInfo(labelFilter.fieldName)
  ) {
    return (
      currentFieldValue.fieldName === labelFilter.fieldName.fieldName &&
      currentFieldValue.type === labelFilter.fieldName.type
    );
  }

  return false;
};

export const isFieldAvailableInCurrentContext = (
  fieldValue: string | BubbleChartSelectedFieldInfo | null,
  numericFields: FieldData[],
  referenceModeFields: AvailableReferenceModeFields
): boolean => {
  if (!fieldValue) {
    return false;
  }

  if (isBubbleChartStringField(fieldValue)) {
    return numericFields.some(field => field.name === fieldValue);
  }

  if (isBubbleChartFieldInfo(fieldValue)) {
    return getAvailableFieldsOfType(fieldValue.type, referenceModeFields).some(
      field => field.name === fieldValue.fieldName
    );
  }

  return false;
};
